import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import { FormGroup } from 'react-nice-inputs';
import Loader from 'js/components/global/Loader';
import ErrorBoundary from 'js/components/global/ErrorBoundary';
import DataService from 'js/modules/dataservice';
import Check from 'js/components/step1/compare/Check';
import Link from 'js/components/step1/compare/Link';
import options from 'js/json/step1/compare/options';

const { isSandals } = window._app.brandOptions;
const { subSessionId = '' } = window._app.page;

class Compare extends Component {

  state = {
    data: null,
    resortOptions: [],
    selectedResorts: [{}, {}, {}],
    readCompare: null,
    isDataReady: false,
  };

  async componentDidMount() {
    this._populateState();
  }

  _populateState = async() => {

    const readCompare = await DataService.readCompare();
    const resortOptions = this._getResorts(readCompare.content);
    const defaultResorts = isSandals
      ? ['sgl', 'brp', 'smb']
      : ['btc', 'bng', 'bbo'];

    const selectedResorts = this._getResortsByCodes(
      defaultResorts,
      readCompare.content
    );

    if (readCompare.code) {
      this.setState({
        readCompare,
        resortOptions,
        selectedResorts,
        isDataReady: true,
      });
    }
  };

  _removeRepetedResortCode = (resortOptions = [], resortCode1 = '', resortCode2 = '') => {

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      return resortOptions.filter(resort => (
        resort.value !== resortCode1
      ));
    }


    return resortOptions.filter(resort => (
      resort.value !== resortCode1 &&
      resort.value !== resortCode2
    ));
  }

  _getResortsByCodes = (resortCodes = [], resortList = []) => (

    resortCodes.map(resortCode => (
      this._findResortByValue(resortCode, resortList)
    ))
  );

  _getResorts = (resorts = []) => {

    return resorts.map(resort => ({
      label: resort.resortName,
      value: resort.rstCode
    }));
  }

  _handleResortChange = (index) => {

    return (value) => {

      // const index = e.target.getAttribute('data-index');
      const resort = this._findResortByValue(
        value, this.state.readCompare.content
      );

      const [...selectedResorts] = this.state.selectedResorts;

      selectedResorts[index] = resort;

      this.setState({ selectedResorts });
    };
  }

  _renderCompareData = (resort) => {

    const hasSelectedResort = Object.keys(resort).length > 0;

    if (hasSelectedResort) {
      return (
        <Fragment>
          {
            options.map(option => {
              const {
                type,
                key,
                // link = '#',
                // label = '',
                arrowDirection = 'left',
                title
              } = option;

              let response = '';

              if (typeof resort[key] === 'object') {
                switch (type) {
                  case 'check':
                    response = (
                      <Check options={resort[key]} />
                    );
                    console.log(response);
                    break;
                  case 'link':
                    response = (
                      <Link
                        options={resort[key]}
                        arrowDirection={arrowDirection} />
                    );
                    break;
                  default:
                    response = (
                      <li />
                    );
                }
              } else if (typeof resort[key] === 'string') {
                response = resort[key] || '';
              }

              console.log(key);

              return (
                <div className="compare-item" key={`value-${key}`}>
                  <span>
                    {title}
                  </span>
                  <span>
                    {response}
                  </span>
                </div>
              );
            })
          }

          <li>
            <a className="details-link" href={window._app.brandOptions.url}>
              <i className="icon-arrow accent-color" />
              <span className="hidden-xs">View</span> details
            </a>
            <a className="resort-link util-txt-center" href={`/?rst_code=${resort.rstCode}&subSessionId=${subSessionId}`}>
              SELECT RESORT
            </a>
          </li>
        </Fragment>
      );
    }


    return (
      <Fragment>
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
        <li className="row" />
      </Fragment>
    );
  };

  _findResortByValue(value = '', resorts = []) {

    const resortOptions = resorts.find(resort => (
      resort.rstCode.toLowerCase() === value.toLowerCase()
    ));

    return resortOptions || {};
  }

  render() {
    const [...selectedResorts] = this.state.selectedResorts;
    const isNotMobile = window.innerWidth > 768;

    console.log(selectedResorts);
    if (!this.state.isDataReady) {
      return <Loader />;
    }

    return (
      <div className="vw-cmpr">
        <div className="selects row">
          <FormGroup
            type="select"
            name="compare-resort1"
            onChange={this._handleResortChange(0)}
            classList={[]}
            boxClassList={['select-blocks', 'sm-6', 'md-4']}
            defaultText={isNotMobile ? 'Select Resort 1' : 'Select...'}
            options={this._removeRepetedResortCode(
              this.state.resortOptions,
              this.state.selectedResorts[1].rstCode,
              this.state.selectedResorts[2].rstCode,
            )}
            value={this.state.selectedResorts[0].rstCode}
          />
          <FormGroup
            type="select"
            name="compare-resort2"
            onChange={this._handleResortChange(1)}
            classList={[]}
            boxClassList={['select-blocks', 'sm-6', 'md-4']}
            defaultText={isNotMobile ? 'Select Resort 2' : 'Select...'}
            options={this._removeRepetedResortCode(
              this.state.resortOptions,
              this.state.selectedResorts[0].rstCode,
              this.state.selectedResorts[2].rstCode,
            )}
            value={this.state.selectedResorts[1].rstCode}
          />
          <FormGroup
            type="select"
            name="compare-resort3"
            onChange={this._handleResortChange(2)}
            classList={[]}
            boxClassList={['select-blocks', 'sm-6', 'md-4']}
            defaultText={isNotMobile ? 'Select Resort 3' : 'Select...'}
            options={this._removeRepetedResortCode(
              this.state.resortOptions,
              this.state.selectedResorts[0].rstCode,
              this.state.selectedResorts[1].rstCode,
            )}
            value={this.state.selectedResorts[2].rstCode}
          />
        </div>
        <div className="resort-attributes" >

          {selectedResorts.map((resort, index) => {
            return (
              <ul className="data-block md-4 sm-6" key={index}>
                {this._renderCompareData(resort)}
              </ul>
            );
          })}
        </div>
      </div>
    );

    /*
    return (
      <div className="vw-cmpr">
        <section className="banner">
          <div className="container util-pr">
            <div className={
              `selects row sm-offset-3 md-offset-3 sm-9 md-9
              ${isBeaches ? 'hidden-md-up' : ''}`}>
              <FormGroup
                type="select"
                name="compare-resort1"
                onChange={this._handleResortChange(0)}
                classList={[]}
                boxClassList={['select-blocks', 'sm-6', 'md-4']}
                defaultText={isNotMobile ? 'Select Resort 1' : 'Select...'}
                options={this._removeRepetedResortCode(
                  this.state.resortOptions,
                  this.state.selectedResorts[1].rstCode,
                  this.state.selectedResorts[2].rstCode,
                )}
                value={this.state.selectedResorts[0].rstCode}
              />
              <FormGroup
                type="select"
                name="compare-resort2"
                onChange={this._handleResortChange(1)}
                classList={[]}
                boxClassList={['select-blocks', 'sm-6', 'md-4']}
                defaultText={isNotMobile ? 'Select Resort 2' : 'Select...'}
                options={this._removeRepetedResortCode(
                  this.state.resortOptions,
                  this.state.selectedResorts[0].rstCode,
                  this.state.selectedResorts[2].rstCode,
                )}
                value={this.state.selectedResorts[1].rstCode}
              />
              <FormGroup
                type="select"
                name="compare-resort3"
                onChange={this._handleResortChange(2)}
                classList={[]}
                boxClassList={['select-blocks', 'sm-6', 'md-4']}
                defaultText={isNotMobile ? 'Select Resort 3' : 'Select...'}
                options={this._removeRepetedResortCode(
                  this.state.resortOptions,
                  this.state.selectedResorts[0].rstCode,
                  this.state.selectedResorts[1].rstCode,
                )}
                value={this.state.selectedResorts[2].rstCode}
              />
            </div>
            {
              isBeaches &&
              <div className="resort-titles row md-offset-3 md-9 hidden-md-down">
                {
                  selectedResorts.map((resort, index) => (
                    <h3 key={resort.resortName + index} className="sm-4">
                      <i className="icon-beaches d-block" />
                      {resort.resortName}
                    </h3>
                  ))
                }
              </div>
            }
          </div>
        </section>
        <section>
          <div className="container">
            <div className="results">
              <div className="data sm-9 md-9">
                <div className="row">
                  {selectedResorts.map((resort, index) => {
                    return (
                      <ul className="data-block md-4 sm-6" key={index}>
                        {this._renderCompareData(resort)}
                      </ul>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );

    */
  }
}

if (!module.hot) {
  render(
    <ErrorBoundary><Compare /></ErrorBoundary>,
    document.querySelector('#root')
  );
}

export default Compare;



// WEBPACK FOOTER //
// ./js/views/step1/Compare.js